module.exports = __webpack_public_path__ + "assets/img/ja-b93e1ce2.png";